import styled from 'styled-components';
import { MobileScreen } from '../styles/ConstantMediaQuery';

const HeaderImageWithLabelWrapper = styled.header`
    display: flex;
    justify-content: center;
    margin: 0 auto;
    position: relative;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '550px')};

    div:first-child {
        margin-right: 10px;
    }
    
    @media ${MobileScreen} {
        width: 100%;
    }
`;

export default HeaderImageWithLabelWrapper;
